import React from 'react'
import { ReactComponent as RemoveIcon } from 'assets/icons/trash.svg'
import { ReactComponent as DownloadIcon } from 'assets/icons/add.svg'
import { ReactComponent as ShowIcon } from 'assets/icons/loupe.svg'
import IconButton from '@material-ui/core/IconButton'
import styles from 'components/Shared/FileChip/FileChip.module.css'
import { getFileExtension } from 'utils/utils'
import AccessControls from './AccessControls'
import classNames from 'classnames'
import Tooltip from '@material-ui/core/Tooltip'

export function FileChip ({ file, onRemove, onDownload, onShow, accessDetails, classes, disabled }) {

  return (
    <li className={classNames(styles.fileChipsContainer, classes?.chipContainer)}>
      <Tooltip title={file.filename}>
        <div className={classNames(styles.nameContainer, classes?.nameContainer)}>
          <span className={styles.name}>
            {file.filename.slice(0, file.filename.length - 4)}
          </span>
          <span>.{getFileExtension(file.filename)}</span>
        </div>
      </Tooltip>
      <div className={'flex-grow-1'}></div>
      <div>
        {accessDetails && <AccessControls accessDetails={accessDetails}/>}
        {onDownload &&
        <IconButton className={styles.button + ' mb-1'}
                    onClick={() => onDownload(file)}><DownloadIcon/></IconButton>
        }
        {onShow &&
        <IconButton className={styles.button}
                    onClick={() => onShow(file)}><ShowIcon/></IconButton>
        }
        {!disabled && onRemove &&
        <IconButton className={styles.button}
                    onClick={() => onRemove(file)}><RemoveIcon/></IconButton>
        }
      </div>
    </li>
  )
}
